package com.hyperether.goodjob.util

import com.hyperether.goodjob.repository.remote.model.ParsedAddress
import com.hyperether.goodjob.repository.remote.model.Place

object LocationUtil {
    fun parseFormattedAddress(place: Place): ParsedAddress {
        val parts = place.formattedAddress.split(", ").map { it.trim() }

        if (parts.size < 2) return ParsedAddress(
            null,
            null,
            null,
            null,
            place.formattedAddress,
            place.location
        )

        val country = parts.lastOrNull() ?: ""
        val street = parts.firstOrNull() ?: ""

        val remainingParts = parts.subList(1, parts.size - 1) // Exclude address and country

        val zip = remainingParts.firstOrNull { it.matches(Regex("\\d{4,5}")) } ?: ""
        val city = remainingParts.firstOrNull { it != zip } ?: ""

//        val street = parts.getOrNull(0)  // First part is usually the street
//        val cityZip = parts.getOrNull(1) // Second part contains city & ZIP
//        val country = parts.getOrNull(2) // Third part is the country
//
//        var city: String? = null
//        var zip: String? = null
//
//        cityZip?.let {
//            val match = Regex("(.*)\\s(\\d{5,})").find(it)
//            if (match != null) {
//                city = match.groupValues[1].trim()  // Extract city
//                zip = match.groupValues[2].trim()   // Extract ZIP code
//            } else {
//                city = it  // Fallback: if no ZIP found, treat entire part as city
//            }
//        }

        return ParsedAddress(city, zip, street, country, place.formattedAddress, place.location)
    }
}